<template>
    <div id="app">
        <div class="reviews-container" v-if="reviews">
            <article
                class="advies-keuze-review"
                role="article"
                itemprop="review"
                itemscope=""
                itemtype="http://schema.org/Review"
                v-for="review in filteredReviews"
                :key="`${review.Score}_${review.Date}`"
            >
                <div class="review-box">
                    <div class="review-author" itemprop="author">{{ review.Reviewer }}</div>
                    <div class="review-rating">
                        <RatingStars :score="review.Score" />
                    </div>
                    <div class="review-quote" itemprop="reviewBody">"{{ review.Text.trim() }}"</div>
                    <div class="review-date" itemprop="datePublished" :content="review.Date">{{ formatDate(review.Date) }}</div>
                    <div itemprop="reviewRating" itemscope="" itemtype="http://schema.org/Rating">
                        <meta itemprop="worstRating" content="1">
                        <meta itemprop="ratingValue" :content="review.Score">
                        <meta itemprop="bestRating" content="5">
                    </div>
                </div>
            </article>
            <div class="button-box">
                <button class="show-more-button"
                    v-if="!maxReviewAmount"
                    @click="loadMore()"
                >
                    Toon meer
                </button>
            </div>
        </div>
    </div>
</template>

<script>
const axios = require('axios');
import RatingStars from './components/RatingStars.vue';

export default {
    name: 'app',
    data() {
        return {
            review_count: null,
            reviews: null,
            display_reviews_amount: 6,
        }
    },
    methods: {
        getReviews() {
            axios.get(`https://api.advieskeuze.nl/feed/reviews/c2b3708e-4a10-458b-af42-48639140637e?json=true`)
                .then(({data}) => {
                    this.review_count = data.ReviewCount;
                    this.reviews = data.Reviews;
                });
        },
        formatDate(date) {
            const options = {year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(date).toLocaleDateString('nl-NL', options);
        },
        loadMore() {
            if(!this.maxReviewAmount) {
                this.display_reviews_amount = this.display_reviews_amount + 5;
            }
        },
    },
    computed: {
        filteredReviews() {
            return this.reviews.filter((i, index) => (index < this.display_reviews_amount));
        },
        totalReviews() {
            return this.reviews.length;
        },
        maxReviewAmount() {
            return this.totalReviews < this.display_reviews_amount;
        }
    },
    created () {
        this.getReviews();
    },
    components: {
        RatingStars,
    },
}
</script>

<style lang="scss">
    .reviews-container {
        .advies-keuze-review {
            font-family: 'Poppins', Helvetica, Arial, Lucida, sans-serif;
            border-bottom: 1px solid #d9d9d9;
            padding-bottom:30px;
            margin-bottom:30px;

            p {
                margin:0;
                padding:0;
            }

            .review-author {
                font-weight: bold;
                font-size:18px;
                color:#015f46;
                margin-bottom:5px;
            }

            .review-quote {
                font-style: italic;
                font-size: 17px;
                line-height: 22px;
                font-weight: 300;
                letter-spacing: 0.3px;
                padding: 10px 10px 10px 0;
            }

            .review-date {
                font-size:14px;
                color:#868686;
            }
        }

        .button-box {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom:30px;

            .show-more-button {
                border-width:0;
                cursor:pointer;
                padding: 22px 43px;
                font-weight: 700;
                background-color: #007858;
                color: #fff;
                font-size: 21px;
                line-height: 30px;
                -webkit-appearance: none;
                -webkit-font-smoothing: antialiased;
                transition: all .3s ease-out;

                &:hover {
                    background-color: #005f45;
                }

                &:focus {
                    outline: none;
                }

                &:-moz-focus-inner {
                    padding: 0;
                    border-style: none;
                }
            }
        }
    }
</style>
